import { Box } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import NurseNotes from '../../../OutPatients/PatientDetails/NurseNotes'
import '../IpPatientDetails.css'

class Vitals extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <Box>
        <NurseNotes
          fromVitals={true}
          is_From_IpNotes = {this.props.is_From_IpNotes }
          is_From_FO_IpNotes={this.props.is_From_FO_IpNotes}
          is_From_FO_opNotes   = {this.props.is_From_FO_opNotes }
        />
      </Box>
    )
  }
}

export default withTranslation()(Vitals)